import { createDiagnostics } from '@finn-no/analysis';

const diagnostics = createDiagnostics('displayads');

export default diagnostics;
